import DataForm from './DataForm';
import EditDataForm from './EditDataForm';

export { EditDataForm };

export default DataForm;
